<template>
  <div class="container mx-auto">
    <el-dialog
      title="Cargar renta personalizada"
      :visible.sync="showCustomRenta"
      width="500px"
    >
      <input type="file" ref="customRenta" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showCustomRenta = false"
          >Cancelar</el-button
        >
        <el-button size="small" type="primary" @click="updateCustomRenta"
          >Calcular</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="`${previewDetail != null ? previewDetail.fullName : ''}`"
      :visible.sync="showBonusDays"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="bonus15Days"
        :model="bonusPaysheet"
        class="flex flex-row justify-center"
        :rules="bonusPaysheetRules"
      >
        <el-form-item prop="days">
          <el-input-number
            v-model="bonusPaysheet.days"
            :min="0"
            :max="15"
            :step="1"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showBonusDays = false"
          >Cancelar</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="
            updateEmployeeWorkDays(previewDetail, bonusPaysheet, 'bonus15Days')
          "
          >Guardar</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="Nueva nómina"
      :visible.sync="showNewPaysheet"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-alert
        v-if="errorMessage"
        :closable="false"
        :title="errorMessage"
        type="error"
        show-icon
        class="mb-5"
      />
      <el-form
        :model="newPaysheetForm"
        status-icon
        :rules="newPaysheetFormRules"
        ref="newPaysheet"
        @submit.native.prevent="
          submitNewPaysheetType('newPaysheet', newPaysheetForm)
        "
      >
        <el-row :gutter="15">
          <el-col :span="9">
            <el-form-item label="Tipo de nómina" prop="paysheetType">
              <el-select
                v-model="newPaysheetForm.paysheetType"
                class="w-full"
                size="small"
                filterable
                clearable
                @change="
                  setNewPaysheet(newPaysheetForm, paysheetTypes, paysheets)
                "
              >
                <el-option
                  v-for="p in paysheetTypes"
                  :key="p.id"
                  :label="`${p.code} - ${p.name}`"
                  :value="p.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Código">
              <el-input
                v-model="newPaysheetForm.code"
                placeholder="Código"
                class="w-full"
                size="small"
                readonly
                :disabled="errorMessage != null"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Fecha inicial">
              <el-input
                size="small"
                v-model="newPaysheetForm.startDate"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                prefix-icon="el-icon-date"
                v-mask="'##/##/####'"
                readonly
                :disabled="errorMessage != null"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Fecha final">
              <el-input
                size="small"
                v-model="newPaysheetForm.endDate"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                prefix-icon="el-icon-date"
                v-mask="'##/##/####'"
                readonly
                :disabled="errorMessage != null"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewPaysheet = false"
            >Cancelar</el-button
          >
          <el-button
            size="small"
            type="primary"
            native-type="submit"
            :disabled="errorMessage != null"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <div class="flex flex-col space-y-4">
      <div class="grid grid-cols-12 gap-4">
        <div class="flex col-span-2">
          <el-select
            v-model="selectedPaysheet"
            placeholder="Nóminas activas"
            size="small"
            filterable
            @change="getPaysheetData(selectedPaysheet)"
          >
            <el-option
              v-for="o in activePaysheets"
              :key="o.id"
              :label="o.code"
              :value="o.id"
            />
          </el-select>
          <div>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              class="ml-2"
              @click="openNewPaysheet()"
            />
          </div>
        </div>
        <div class="flex items-center col-span-6 border rounded px-2">
          <div class="flex space-x-4" v-if="selectedPaysheet != ''">
            <div class="flex space-x-2">
              <h2 class="font-semibold">CÓDIGO:</h2>
              <span>{{
                paysheetDetails != null ? paysheetDetails.code : ""
              }}</span>
            </div>
            <div class="flex space-x-2">
              <h2 class="font-semibold">FECHAS:</h2>
              <span>
                {{ paysheetDetails != null ? paysheetDetails.startDate : "" }} -
                {{ paysheetDetails != null ? paysheetDetails.endDate : "" }}
              </span>
            </div>
            <div class="flex space-x-2">
              <h2 class="font-semibold">TIPO:</h2>
              <span class="uppercase">
                {{
                  paysheetDetails != null
                    ? paysheetDetails.paysheetType.name
                    : ""
                }}
              </span>
            </div>
          </div>
          <div v-else>
            <h2>SELECCIONA O CREA UNA PLANTILLA PARA VER SUS DETALLES</h2>
          </div>
        </div>
        <div class="flex col-span-4 space-x-4">
          <el-input
            v-model="searchValue"
            placeholder="Buscar"
            suffix-icon="el-icon-search"
            size="small"
            clearable
          />
          <div>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-check"
              @click="proccessPaysheet(selectedPaysheet, computedEmployees)"
              >Procesar planilla</el-button
            >
          </div>
          <el-dropdown trigger="click">
            <el-button icon="el-icon-fa-ellipsis-v" size="small"></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="
                  generateGratificationDiscountReport(
                    selectedPaysheet,
                    computedEmployees,
                    'gratificaciones'
                  )
                "
                ><i class="el-icon-download"></i> Descargar
                gratificaciones</el-dropdown-item
              >
              <el-dropdown-item
                @click.native="
                  generateGratificationDiscountReport(
                    selectedPaysheet,
                    computedEmployees,
                    'descuentos'
                  )
                "
              >
                <i class="el-icon-download"></i> Descargar
                descuentos</el-dropdown-item
              >
              <el-dropdown-item
                divided
                @click.native="printSelectedPaysheet(computedEmployees)"
                class="font-semibold"
              >
                <i class="el-icon-printer"></i> Descargar
                planilla</el-dropdown-item
              >
              <el-dropdown-item
                divided
                class="font-semibold"
                @click.native="showCustomRenta = true"
                :disabled="computedEmployees.length == 0"
                v-if="allowCustomRenta"
              >
                <i class="el-icon-upload2"></i> Subir renta
                personalizada</el-dropdown-item
              >
              <el-dropdown-item
                divided
                class="font-semibold"
                @click.native="confirmCleanPayrollValue()"
                :disabled="computedEmployees.length == 0"
                v-if="false"
              >
                <i class="el-icon-delete"></i> Limpiar valor planilla
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4">
        <div
          class="
            flex flex-col
            justify-between
            col-span-2
            bg-gray-100
            h-120
            border
            rounded
            p-3
            sticky
            top-0
            text-xs
          "
          v-loading="loadingPreview"
        >
          <div class="flex flex-col space-y-3">
            <div>
              <span class="font-semibold">Nombre completo</span>
              <template v-if="previewDetail">
                <el-row :gutter="15" style="font-size: 12px">
                  <el-col :span="24">
                    <span style="font-size: 10.5px">{{
                      previewDetail.fullName.split(" - ")[1]
                    }}</span>
                  </el-col>
                </el-row>
              </template>
            </div>
            <el-row :gutter="15">
              <el-col
                :span="12"
                v-if="
                  paysheets.length > 0 &&
                  selectedPaysheet &&
                  previewDetail != null
                    ? paysheets.find((p) => p.id === selectedPaysheet)
                        .paysheetType.id === '7'
                    : false
                "
                class="text-blue-700 hover:text-black cursor-pointer"
              >
                <a @click="showBonusDaysDialog(previewDetail.workedDays)">
                  <span class="font-semibold"> D. laborados </span>

                  <p style="font-size: 10.5px">
                    {{
                      this.previewDetail != null
                        ? `${this.previewDetail.workedDays}`
                        : ""
                    }}
                  </p>
                </a>
              </el-col>
              <el-col :span="12" v-else>
                <span class="font-semibold">D. laborados</span>
                <p style="font-size: 10.5px">
                  {{
                    this.previewDetail != null
                      ? `${this.previewDetail.workedDays}`
                      : ""
                  }}
                </p>
              </el-col>
              <el-col :span="12">
                <span class="font-semibold">D. ausente</span>
                <p style="font-size: 10.5px">
                  {{
                    this.previewDetail != null
                      ? `${this.previewDetail.missedDays}`
                      : ""
                  }}
                </p>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="12">
                <span class="font-semibold">Salario</span>
                <p style="font-size: 10.5px">
                  {{
                    this.previewDetail != null
                      ? `${this.previewDetail.salary}`
                      : ""
                  }}
                </p>
              </el-col>
              <el-col :span="12">
                <span class="font-semibold">Planilla</span>
                <p style="font-size: 10.5px">
                  {{
                    this.previewDetail != null
                      ? `${this.previewDetail.salaryForPayroll}`
                      : ""
                  }}
                </p>
              </el-col>
            </el-row>
            <div>
              <span class="font-semibold">Horas extra</span>
              <template v-if="previewDetail">
                <el-row
                  :gutter="15"
                  v-for="(item, k) of previewDetail.horasextra"
                  :key="k"
                  style="font-size: 10.5px"
                >
                  <el-col :span="20">
                    <span class="uppercase"
                      >{{ item.date | formatDate }} /
                      {{ item.overtimeType.name }}</span
                    >
                  </el-col>
                  <el-col :span="4" class="flex justify-end">
                    <span>{{ item.hours }}</span>
                  </el-col>
                </el-row>
              </template>
            </div>
            <div class="w-full">
              <span class="font-semibold">Administrativas</span>
              <template v-if="previewDetail">
                <el-row
                  :gutter="15"
                  v-for="(item, k) of previewDetail.administrativas"
                  :key="k"
                  style="font-size: 10.5px"
                >
                  <el-col :span="20">
                    <span class="uppercase">{{
                      item.personalAction.name
                    }}</span>
                  </el-col>
                  <el-col :span="4" class="flex justify-end">
                    <span>{{
                      item.personalAction.discount
                        ? item.value * -1
                        : item.value | formatMoney
                    }}</span>
                  </el-col>
                </el-row>
              </template>
            </div>
            <div class="w-full">
              <span class="font-semibold">Gratificaciones</span>
              <template v-if="previewDetail">
                <el-row
                  :gutter="15"
                  v-for="(item, k) of previewDetail.gratificaciones"
                  :key="k"
                  style="font-size: 10.5px"
                  class="rounded cursor-pointer hover:bg-orange-200"
                  @click.native="toggleIncludePersonalAction(item)"
                >
                  <el-col :span="20">
                    <span
                      class="uppercase"
                      :class="{ 'line-through': item.tempDisabled }"
                      >{{ item.personalAction.name }}</span
                    >
                  </el-col>
                  <el-col :span="4" class="flex justify-end">
                    <span :class="{ 'line-through': item.tempDisabled }">{{
                      item.value | formatMoney
                    }}</span>
                  </el-col>
                </el-row>
              </template>
            </div>
            <div class="w-full">
              <span class="font-semibold">Descuentos</span>
              <template v-if="previewDetail">
                <el-row
                  :gutter="15"
                  v-for="(item, k) of previewDetail.descuentos"
                  :key="k"
                  style="font-size: 10.5px"
                  class="rounded cursor-pointer hover:bg-orange-200"
                  @click.native="toggleIncludePersonalAction(item)"
                >
                  <el-col :span="20">
                    <span
                      class="uppercase"
                      :class="{ 'line-through': item.tempDisabled }"
                      >{{ item.personalAction.name }}</span
                    >
                  </el-col>
                  <el-col :span="4" class="flex justify-end">
                    <span :class="{ 'line-through': item.tempDisabled }">{{
                      item.value | formatMoney
                    }}</span>
                  </el-col>
                </el-row>
              </template>
            </div>
          </div>
          <el-button
            v-if="previewDetail"
            size="mini"
            type="primary"
            class="font-semibold"
            @click.native="openShowAssignAP(previewDetail)"
          >
            <i class="el-icon-fa-bolt"></i> Acciones de personal
          </el-button>
        </div>
        <div class="col-span-10 flex flex-col space-y-4">
          <div class="flex flex-row justify-between space-x-6 text-sm">
            <div class="flex flex-col space-y-2">
              <span
                v-if="customRenta"
                class="
                  bg-yellow-200
                  border-yellow-400
                  rounded
                  px-4
                  py-1
                  leading-none
                  text-yellow-900 text-xs
                  uppercase
                "
              >
                El calculo de renta se ha agregado de manera personalizada</span
              >
              <span
                v-if="cleanedPayrollValue"
                class="
                  bg-blue-200
                  border-blue-400
                  rounded
                  px-4
                  py-1
                  leading-none
                  text-blue-900 text-xs
                  uppercase
                "
              >
                El valor de planilla ha sido limpiado (Q0.00)</span
              >
            </div>
            <div class="flex flex-row space-x-2">
              <el-checkbox v-model="negativePayments">
                <div class="flex flex-row items-center space-x-1">
                  <span>PAGO NEGATIVO</span>
                  <div class="h-4 w-4 bg-red-500 text-white"></div>
                </div>
              </el-checkbox>
              <div class="flex flex-row items-center space-x-1">
                <span>EMPLEADO SELECCIONADO</span>
                <div class="h-4 w-4 bg-orange-400"></div>
              </div>
            </div>
          </div>
          <div class="flex flex-col" v-loading="loading">
            <div class="flex flex-col sticky top-0">
              <div class="flex flex-row font-semibold text-xs">
                <span
                  v-for="(h, k) in table.headers"
                  :key="k"
                  class="
                    border-b
                    p-1
                    text-xs
                    font-semibold
                    text-gray-600
                    bg-white
                    borded
                  "
                  :style="{ width: table.width[k] }"
                  :class="[
                    table.classes[k],
                    k == 0 ? 'rounded-tl-lg' : '',
                    k == table.headers.length - 1 ? 'rounded-tr-lg' : '',
                  ]"
                  >{{ h }}</span
                >
              </div>
              <div class="flex flex-row font-semibold text-xs bg-white">
                <span
                  v-for="(h, k) in paysheetTotals"
                  :key="k"
                  class="border-b-2 p-1 text-right border-dashed"
                  :style="{ width: table.width[k] }"
                >
                  {{ h != "" ? formatNumber(parseFloat(h.toFixed(2))) : h }}
                </span>
              </div>
            </div>
            <template v-if="filteredEmployees.length > 0">
              <div
                class="flex flex-row text-xs border-b cursor-pointer"
                v-for="(ce, k) of filteredEmployees"
                :class="getRowClasses(k, ce, previewDetail)"
                :key="k"
                @click="showDetails(ce)"
              >
                <div
                  class="p-1"
                  v-for="(h, k) in table.values"
                  :key="k"
                  :style="{ width: table.width[k] }"
                  :class="table.classes[k]"
                >
                  <span v-if="k != table.values.length - 1">{{
                    ce[h] | formatNumber
                  }}</span>
                  <span v-else>{{ ce[h] | formatMoney }}</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                class="h-16 flex flex-row justify-center items-center border-b"
              >
                <span class="text-xs text-gray-400">Sin Datos</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  format,
  startOfMonth,
  endOfMonth,
  setDate,
  differenceInDays,
  differenceInYears,
  min,
} from "date-fns";
import { upperCase } from "voca";
import * as R from "ramda";
import { formatNumber, amountValidate } from "../../../utils";
import XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "AllPaysheets",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          paysheets { 
            id 
            paysheetType { 
              id 
              name 
              code 
              description 
              active 
              rentaDiscount
              isssDiscount
              afpDiscount
              gratification
              discounts
              overtime
              allEmployees
              Q1
              Q2
              month
              type
              paysheetFrecuency { id days } 
            } 
            month 
            year 
            sequence 
            active 
            code 
            startDate 
            endDate 
            allowCustomRenta
            settings
          }
          retirements { id name employer employee documentTypes { id } }
          socialSecurities { id employer employee maxAmount documentTypes { id } }
          paysheetTypes(where: { active: true }) { 
            id 
            name 
            code 
            description 
            active 
            rentaDiscount
            isssDiscount
            afpDiscount
            Q1
            Q2
            month
            paysheetFrecuency { days } 
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) =>
            vm.setData({
              paysheets: data.paysheets,
              retirements: data.retirements,
              socialSecurities: data.socialSecurities,
              paysheetTypes: data.paysheetTypes,
            })
          );
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      loading: false,
      negativePayments: false,
      searchValue: "",
      previewDetail: null,
      loadingPreview: false,
      employees: [],
      paysheets: [],
      showNewPaysheet: false,
      newPaysheetForm: {
        type: "",
      },
      newPaysheetFormRules: {},
      paysheetTypes: [],
      ISRTable: [],
      ISRTableM: [],
      pensionForm: {},
      socialForm: {},
      ISRElements: [
        {
          key: "salary",
          name: "SALARIO",
          type: "success",
        },
        {
          key: "-",
          name: "-",
          type: "info",
        },
        {
          key: "(",
          name: "(",
          type: "info",
        },
        {
          key: "pen_emp",
          name: "PENSION EMP.",
          type: "success",
        },
        {
          key: "+",
          name: "+",
          type: "info",
        },
        {
          key: "soc_emp",
          name: "SEG. SOC. EMP",
          type: "success",
        },
        {
          key: ")",
          name: ")",
          type: "info",
        },
      ],
      selectedPaysheet: "",
      errorMessage: null,
      overtimes: [],
      rawEployees: [],
      personalActions: [],
      table: {
        headers: [
          "",
          "Nombre completo",
          "Días",
          "Salario",
          "Planilla",
          "H. extra",
          "Gratifc.",
          "Subtotal",
          "IGSS",
          "Renta",
          "Descuen.",
          "Pago",
        ],
        classes: [
          "",
          "",
          "text-center",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right font-medium",
        ],
        width: [
          "3.5%",
          "26.5%",
          "4%",
          "6%",
          "7%",
          "6.5%",
          "6.5%",
          "7%",
          "6%",
          "6.5%",
          "6.5%",
          "7.5%",
        ],
        values: [
          "index",
          "fullName",
          "workedDays",
          "salary",
          "salaryForPayroll",
          "overtime",
          "gratification",
          "subtotalSalary",
          "socialEmployee",
          "taxes",
          "discounts",
          "total",
        ],
      },
      computedEmployees: [],
      apPersonalActionsDetails: [],
      apPersonalActions: [],
      showAssignAP: [],
      apTypes: [
        {
          name: "Administrativas",
          id: "1",
        },
        {
          name: "Gratificaciones",
          id: "2",
        },
        {
          name: "Descuentos",
          id: "3",
        },
      ],
      customRenta: false,
      showCustomRenta: false,
      customRentaData: [],
      cleanedPayrollValue: false,
      paysheetTotals: ["", "", "", "", 0, 0, 0, 0, 0, 0, 0, 0],
      priorPaysheets: [],
      priorPersonalActions: [],
      bonusPaysheet: {
        days: 10,
      },
      bonusPaysheetRules: {
        days: amountValidate("change", true, 0, 15),
      },
      showBonusDays: false,
    };
  },
  methods: {
    setData({ paysheets, retirements, socialSecurities, paysheetTypes }) {
      this.paysheetTypes = paysheetTypes.filter((pt) => {
        const thisMonth = new Date().getMonth() + 1;
        return pt.month == 0 || pt.month == thisMonth;
      });
      this.paysheets = paysheets.map((p) => {
        return {
          ...p,
          startDate: format(p.startDate, "DD/MM/YYYY"),
          endDate: format(p.endDate, "DD/MM/YYYY"),
        };
      });

      const afp = retirements.find((r) => r.name === "AFP");
      const ipsfa = retirements.find((r) => r.name === "IPSFA");
      this.pensionForm = {
        afp: {
          employee: afp.employee,
          employer: afp.employer,
          documentTypes: afp.documentTypes.map((dt) => dt.id),
        },
        ipsfa: {
          employee: ipsfa.employee,
          employer: ipsfa.employer,
          documentTypes: ipsfa.documentTypes.map((dt) => dt.id),
        },
      };
      this.socialForm = {
        ...socialSecurities[0],
        documentTypes: socialSecurities[0].documentTypes.map((dt) => dt.id),
      };
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = Array(columns.length).fill("");
      sums[1] = "Totales";

      let tsalary = 0;
      let tsalaryForPayroll = 0;
      let tovertime = 0;
      let tgratification = 0;
      let tdiscounts = 0;
      let tsubtotal = 0;
      let ttaxes = 0;
      let tsocial = 0;
      let ttotal = 0;

      for (const value of data) {
        const {
          salary,
          salaryForPayroll,
          overtime,
          gratification,
          discounts,
          taxes,
          socialEmployee,
          total,
          subtotalSalary,
        } = value;
        tsalary += salary;
        tsalaryForPayroll += salaryForPayroll;
        tovertime += overtime;
        tgratification += gratification;
        tdiscounts += discounts;
        ttaxes += taxes;
        tsocial += socialEmployee;
        ttotal += total;
        tsubtotal += subtotalSalary;
      }

      sums[3] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(tsalary);
      sums[4] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(tsalaryForPayroll);
      sums[5] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(tovertime);
      sums[6] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(tgratification);
      sums[7] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(tsubtotal);
      sums[8] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(tsocial);
      sums[9] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(ttaxes);
      sums[10] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(tdiscounts);
      sums[11] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(ttotal);

      return sums;
    },
    openNewPaysheet() {
      if (!R.isNil(this.$refs.newPaysheet)) {
        this.$refs.newPaysheet.resetFields();
      }
      this.errorMessage = null;
      this.showNewPaysheet = true;
    },
    showDetails(data) {
      this.loadingPreview = true;
      setTimeout(() => {
        this.previewDetail = data;
        this.loadingPreview = false;
      }, 1000);
    },
    setNewPaysheet({ paysheetType }, paysheetTypes, paysheets) {
      // Limpia el codigo, fecha de inicio y fecha final
      this.newPaysheetForm["code"] = "";
      this.newPaysheetForm["startDate"] = "";
      this.newPaysheetForm["endDate"] = "";

      axios
        .post("/", {
          query: `{
            paysheets { id paysheetType { id name paysheetFrecuency { id days } } month year sequence active code startDate endDate allowCustomRenta  }
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          const paysheets = data.paysheets;

          const currentDate = new Date();
          const selectedType = paysheetTypes.find((p) => p.id == paysheetType);

          // encuentra paysheet segun mes y año actual
          const month = format(currentDate, "MM");
          const year = format(currentDate, "YY");
          const monthapysheets = paysheets.filter(
            (p) =>
              p.month == month &&
              p.year == year &&
              p.paysheetType.id == paysheetType
          );

          const sequence = monthapysheets.length + 1;
          let startDate =
            sequence == 1
              ? format(startOfMonth(currentDate), "DD/MM/YYYY")
              : format(setDate(currentDate, 16), "DD/MM/YYYY");
          let endDate =
            selectedType.paysheetFrecuency.days === 15 && sequence == 1
              ? format(setDate(currentDate, 15), "DD/MM/YYYY")
              : format(endOfMonth(currentDate), "DD/MM/YYYY");

          const periodPaysheets = paysheets.filter(
            (p) =>
              p.year == year &&
              p.month == month &&
              p.paysheetType.id == paysheetType
          );

          // Verifica si hay alguna activa
          const activePaysheet = periodPaysheets.filter((p) => p.active);
          if (activePaysheet.length > 0) {
            this.errorMessage =
              "Hay una planilla activa todavia, debes finalizarla primero para poder crear otra.";
            return false;
          } else {
            this.errorMessage = null;
          }

          // Verifica que haya secuencia disponible
          const inactivePaysheet = periodPaysheets.filter((p) => !p.active);
          let maxCount = null;
          switch (selectedType.days) {
            case 15:
              // Se pueden maximo 2 al mes
              maxCount = 2;
              break;
            case 30:
              // Solo se puede 1 al mes
              maxCount = 1;
              break;
          }
          if (inactivePaysheet.length == maxCount) {
            this.errorMessage =
              "Ya no se puede crear una nueva platilla de este tipo para este mes.";
            return false;
          }

          const code = `${upperCase(format(currentDate, "MMM"))}-${
            selectedType.code
          }-${format(currentDate, "YY")}${sequence}`;
          this.newPaysheetForm = {
            paysheetType,
            code,
            startDate,
            endDate,
            month,
            year,
            sequence,
          };
        });
    },
    submitNewPaysheetType(formName, data) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }

        this.$confirm(
          "¿Estás seguro que deseas crear esta nueva nómina?",
          "Confirmación",
          {
            confirmButtonText: "Si, crear",
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                const startDate = data.startDate.split("/");
                const endDate = data.endDate.split("/");
                axios
                  .post("/", {
                    query: `mutation {
                    paysheetCreate(
                      data: {
                        paysheetType: "${data.paysheetType}"
                        code: "${data.code}"
                        startDate: "${startDate[2]}-${startDate[1]}-${startDate[0]}"
                        endDate: "${endDate[2]}-${endDate[1]}-${endDate[0]}"
                        month: "${data.month}"
                        year: "${data.year}"
                        sequence: ${data.sequence}
                      }
                    ){ id paysheetType { id name days } month year sequence active code startDate endDate }
                  }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.paysheets = data.paysheetCreate;
                    }
                    1;
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se ha creado la nueva nómina correctamente"
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "Si, crear";
                    this.showNewPaysheet = false;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    tableRowClassName() {
      return "cursor-pointer";
    },
    async getEmployees(getLastPaysheets = false) {
      this.rawEployees = [];
      let lastPaysheetRequest = "";
      if (getLastPaysheets) {
        for (const id of getLastPaysheets) {
          lastPaysheetRequest += `
          PH${id}: paysheetHistory(where: {paysheet: ${id}} ) {
            employee { id }
            subtotalSalary
            socialEmployee
            socialEmployer
            afpEmployee
            afpEmployer
            taxes
          }
          PAH${id}: personalActionHistory(where: {paysheet: ${id}} ) {
            employee { id }
            PAdeductISR
            value
          }
        `;
        }
      }
      if (this.selectedPaysheet) {
        // Obtiene todos los empleados y acciones de personal aplicables
        const { data } = await axios.post("/", {
          query: `{
            employees (where: { show: true } whereNot: { status: 1 }) {
              id
              code
              priorCode
              name1
              name2
              name3
              lastname1
              lastname2
              lastname3
              currentSalary
              contractStartDate
              paysheetType { id }
              documents { number documentType { id } }
              includeInPaysheet
              terminated
              oldDepartment { name }
              oldCostCenter { name }
              procuAguinaldo
            }
            employeePersonalActions (whereNot:{personalAction: "1"}) {
              id
              employee { id }
              personalAction { id type name affectsMethod baseSalary termination discount deductISR }
              value
              affectsPaysheet
              isRecurrent
              quincenaUno
              quincenaDos
              startDate
              endDate
              amount
              tempDisabled
              eventDate
            }
            overtimes (where: {status: true paid: false}) { id employee { id } date hours overtimeType { name factor} hourlySalary comment }
            isrRanges { id name from until percentage applyTo fixedAmount paysheetFrecuency { id } }
            ${lastPaysheetRequest}
          }`,
        });
        this.rawEployees = data.data.employees;
        this.personalActions = data.data.employeePersonalActions;
        this.overtimes = data.data.overtimes;
        this.ISRTable = data.data.isrRanges.filter(
          (r) => r.paysheetFrecuency.id == 2
        );
        this.ISRTableM = data.data.isrRanges.filter(
          (r) => r.paysheetFrecuency.id == 1
        );
        this.priorPaysheets = [];
        this.priorPersonalActions = [];
        if (getLastPaysheets) {
          for (const id of getLastPaysheets) {
            this.priorPaysheets = this.priorPaysheets.concat(
              data.data[`PH${id}`]
            );
            this.priorPersonalActions = this.priorPersonalActions.concat(
              data.data[`PAH${id}`]
            );
          }
        }
      }
    },
    proccessPaysheet(paysheetID, employees) {
      this.$confirm(
        "¿Estás seguro que deseas procesar esta planilla?",
        "Confirmación",
        {
          confirmButtonText: "Si, procesar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";

              let horasextra = "";
              let personalactions = "";
              let values = "";
              for (const employee of employees) {
                if (employee.horasextra.length > 0 && employee.workedDays > 0) {
                  for (const he of employee.horasextra) {
                    horasextra += `{
                      hours: ${he.hours},
                      factor: ${he.overtimeType.factor},
                      name: "${he.overtimeType.name}",
                      date: "${he.date}",
                      comment: "${he.comment}",
                      employee: "${employee.id}",
                      overtime: "${he.id}",
                      paysheet: "${paysheetID}",
                      value: ${parseFloat(
                        (
                          he.hours *
                          he.overtimeType.factor *
                          (employee.salary  * 12 / 365 / 8)
                        ).toFixed(2)
                      )},
                    }`;
                  }
                }
                if (
                  employee.gratificaciones.length > 0 &&
                  employee.workedDays > 0
                ) {
                  for (const g of employee.gratificaciones.filter(
                    (g) => !g.tempDisabled
                  )) {
                    personalactions += `{
                      name: "${g.personalAction.name}",
                      value: ${g.value},
                      amount: ${g.amount},
                      personalAction: "${g.personalAction.id}",
                      employee: "${employee.id}",
                      paysheet: "${paysheetID}",
                      PAdeductISR: ${g.personalAction.deductISR},
                      type: ${g.personalAction.type},
                    }`;
                  }
                }
                if (employee.descuentos.length > 0 && employee.workedDays > 0) {
                  for (const d of employee.descuentos.filter(
                    (d) => !d.tempDisabled
                  )) {
                    personalactions += `{
                      name: "${d.personalAction.name}",
                      value: ${d.value},
                      amount: ${d.amount},
                      personalAction: "${d.personalAction.id}",
                      employee: "${employee.id}",
                      paysheet: "${paysheetID}",
                      PAdeductISR: ${d.personalAction.deductISR},
                      type: ${d.personalAction.type},
                    }`;
                  }
                }

                if (employee.administrativas.length > 0) {
                  for (const d of employee.workedDays === 0
                    ? employee.administrativas.filter(
                        (ea) => ea.personalAction.id === "92"
                      )
                    : employee.administrativas) {
                    personalactions += `{
                      name: "${d.personalAction.name}"
                      value: ${d.value}
                      amount: ${d.amount}
                      personalAction: "${d.personalAction.id}"
                      employee: "${employee.id}",
                      paysheet: "${paysheetID}",
                      PAdeductISR: ${d.personalAction.deductISR},
                      type: ${d.personalAction.type},
                      eventDate: ${d.eventDate ? `"${d.eventDate}"` : null} 
                    }`;
                  }
                }
                values += `{
                  employee: "${employee.id}",
                  paysheet: "${paysheetID}",
                  code: "${employee.code}",
                  fullName: "${employee.fullName}",
                  workedDays: ${employee.workedDays},
                  missedDays: ${employee.missedDays},
                  salary: ${employee.salary},
                  salaryForPayroll: ${employee.salaryForPayroll},
                  overtime: ${employee.overtime},
                  gratification: ${employee.gratification},
                  discounts: ${employee.discounts},
                  subtotalSalary: ${employee.subtotalSalary},
                  taxes: ${employee.taxes},
                  socialEmployee: ${employee.socialEmployee},
                  afpEmployee: ${employee.afpEmployee},
                  socialEmployer: ${employee.socialEmployer},
                  afpEmployer: ${employee.afpEmployer},
                  total: ${employee.total},
                  priorDepartment: "${employee.oldDepartment}",
                  priorCostCenter: "${employee.oldCostCenter}",
                }`;
              }
              axios
                .post("/", {
                  query: `mutation {
                     paysheetProccess(
                      where: {id: "${paysheetID}"}
                      data: {
                        horasextra: [${horasextra}],
                        personalactions: [${personalactions}]
                        paysheet: [${values}]
                      }
                    ){ id paysheetType { id name days } month year sequence active code startDate endDate }
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.paysheets = data.paysheetProccess;
                  }
                  1;
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha procesado la nueva nómina correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, procesar";
                  this.showNewPaysheet = false;
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    printSelectedPaysheet(data) {
      this.$confirm(
        `¿Estás seguro que deseas imprimir esta planilla?`,
        "Confirmación",
        {
          confirmButtonText: `Si, generar`,
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";

              const worksheet = XLSX.utils.json_to_sheet(
                data.map((d) => {
                  const fullName = `${
                    d.lastname1 ? `${d.lastname1.trim()} ` : ""
                  }${d.lastname2 ? `${d.lastname2.trim()} ` : ""}${
                    d.lastname3 ? `${d.lastname3.trim()} ` : ""
                  }${d.name1 ? `${d.name1.trim()} ` : ""} ${
                    d.name2 ? `${d.name2.trim()} ` : ""
                  } ${d.name3 ? `${d.name3.trim()} ` : ""}`;
                  return {
                    N: d.index,
                    CODIGO: d.code,
                    CODIGOANTERIOR: d.priorCode,
                    NOMBRE: fullName
                      .split("  ")
                      .join(" ")
                      .trim(),
                    DIAS: d.workedDays,
                    SALARIO: d.salary,
                    PLANILLA: d.salaryForPayroll,
                    HEXTRA: d.overtime,
                    GRATIFC: d.gratification,
                    SUBTOTAL: d.subtotalSalary,
                    ISSS: d.socialEmployee,
                    RENTA: d.taxes,
                    DESCUEN: d.discounts,
                    PAGO: d.total,
                  };
                })
              );
              const wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, worksheet, "Descuentos");
              XLSX.writeFile(wb, `planilla.xlsx`);
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = `Si, generar`;
              done();
            } else {
              done();
            }
          },
        }
      );
    },
    generateGratificationDiscountReport(paysheet, employees, type) {
      this.$confirm(
        `¿Estás seguro que deseas generar el reporte de ${type}?`,
        "Confirmación",
        {
          confirmButtonText: `Si, generar`,
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";

              const data = [];
              for (const d of employees) {
                for (const a of d[type]) {
                  if (!a.tempDisabled) {
                    data.push({
                      CodigoAnterior: d.priorCode,
                      CodigoActual: d.code,
                      Nombre1: d.name1,
                      Nombre2: d.name2,
                      Nombre3: d.name3,
                      Apellido1: d.lastname1,
                      Apellido2: d.lastname2,
                      Apellido3: d.lastname3,
                      NombreCompleto: [
                        d.lastname1,
                        d.lastname2,
                        d.lastname3,
                        d.name1,
                        d.name2,
                        d.name3,
                      ]
                        .filter((e) => e)
                        .map((e) => e.trim())
                        .join(" "),
                      FechaNac: format(new Date(d.dob), "DD/MM/YYYY"),
                      NombreAccion: a.personalAction.name.trim(),
                      FechaInicioAccion: format(
                        new Date(a.startDate),
                        "DD/MM/YYYY"
                      ),
                      FechaFinalAccion: format(
                        new Date(a.endDate),
                        "DD/MM/YYYY"
                      ),
                      CantidadAccion: a.value,
                    });
                  }
                }
              }

              const filename = `listado-${type}-${format(
                new Date(),
                "YYYYMMDDHHmmss"
              )}`;

              const worksheet = XLSX.utils.json_to_sheet(data);
              const wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, worksheet, type);
              XLSX.writeFile(wb, `${filename}.xlsx`);
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = `Si, generar`;
              done();
            } else {
              done();
            }
          },
        }
      );
    },
    /**
     * Metodo que genera toda la información de la planilla
     * Aca se realizan todos los calculos necesarios
     * Para este momento todo la data necesaria ya se ha descargado
     */
    async getPaysheetData() {
      this.loading = true;
      
      // Resetear flags de modificación personalizada
      this.cleanedPayrollValue = false;
      this.customRenta = false;

      // Obtiene la planilla seleccionada
      const paysheet = this.paysheets.find(
        (p) => p.id === this.selectedPaysheet
      );

      // Define el tipo de planilla
      const paysheetType = paysheet.paysheetType;

      // Define si es planilla anterior
      let priorPaysheets = false;
      if (
        paysheet.sequence == 2 ||
        ["vacacion", "bono15", "aguinaldo"].includes(paysheetType.type)
      ) {
        priorPaysheets = this.paysheets.filter(
          (p) => p.year == paysheet.year && p.month == paysheet.month
        );
      }

      // Si es planilla anterior, pasa el id para obtener el historico
      await this.getEmployees(
        priorPaysheets ? priorPaysheets.map((p) => p.id) : false
      );

      // Obtiene fechas de inicio y fin de la planilla
      const [psday, psmonth, psyear] = paysheet.startDate.split("/");
      const [peday, pemonth, peyear] = paysheet.endDate.split("/");
      const paysheetStartDate = new Date(`${psmonth}/${psday}/${psyear}`);
      const paysheetEndDate = new Date(`${pemonth}/${peday}/${peyear}`);

      /**
       * Obtiene las comisiones de los ultimos 6 meses
       * en caso que sea planilla tipo aguinaldo
       */
      let comisiones = [];
      if (["aguinaldo", "vacacion", "bono15"].includes(paysheetType.type)) {
        comisiones = await this.getComissions();
      }

      let index = 0;
      this.computedEmployees = this.rawEployees
        //.filter((e) =>
        //  [
        //    "30657",
        //    //"30610",
        //    // "30142",
        //    // "30685",
        //    // "30005",
        //    // "30185",
        //    // "30552",
        //    // "30595",
        //    // "30063",
        //    // "30067",
        //    // "30348",
        //  ].includes(e.code)
        //)
        // Filtra a los empleados que aplican en esta planilla
        .filter((e) => {
          // Obtiene la fecha de inicio de contrato del empleado
          const [cyear, cmonth, cday] = e.contractStartDate.split("-");
          const contractStartDate = new Date(`${cmonth}/${cday}/${cyear}`);

          /**
           * Identifica si tiene AP de baja, se usara en caso que la planilla sea aguinaldo
           * Incluye solo AP de baja que
           */
          const personalActionBaja = this.personalActions.find((p) => {
            const [psyear, psmonth, psday] = p.startDate.split("-");
            const startDate = new Date(`${psmonth}/${psday}/${psyear}`);
            return (
              p.personalAction.id == 92 &&
              p.employee.id == e.id &&
              startDate >= paysheetStartDate
            );
          });

          // Si la planilla es aguinaldo o vacacion se verifica si tiene AP baja para excluir de la planilla
          const includeFound = ["aguinaldo", "vacacion", "bono15"].includes(
            paysheet.paysheetType.type
          )
            ? personalActionBaja == null
            : true;

          let includeEmployee = true;
          const vacationMinDays = 365;

          switch (paysheetType.type) {
            case "aguinaldo":
              break;
            case "vacacion":
            case "bono15":
              // Obtiene los dias trasncurridos desde contratacion hasta inicio de planilla
              const daysPastPaysheetStart = differenceInDays(
                paysheetEndDate,
                contractStartDate
              );
              // filtra empleados cuya contractstartDate sea el mismo mes que se corre el paysheet
              includeEmployee =
                cmonth === pemonth && daysPastPaysheetStart >= vacationMinDays;
              break;
            default:
              // filtra todos los empleados que ingresaron antes que termine la planilla
              includeEmployee =
                contractStartDate < paysheetEndDate &&
                e.paysheetType.id == paysheetType.id;
              break;
          }
          return (
            includeEmployee &&
            // Filtra empleados que estan marcados como incluir en la planilla
            e.includeInPaysheet &&
            // Filtra todos los empleados que no estan marcados como terminados
            !e.terminated &&
            // Filtra si la planilla es aguinaldo y tiene AP de baja
            includeFound
          );
        })
        .map((e) => {
          index = index + 1;
          return this.getProcessedEmployeeData(e, comisiones, index);
        });
      this.loading = false;
    },
    getRowClasses(k, ce, previewDetail) {
      const classes = [];
      if (ce.total < 0) {
        classes.push("bg-red-500 hover:bg-red-400 text-white");
      } else if (previewDetail && ce.id == previewDetail.id) {
        classes.push("bg-orange-400 hover:bg-orange-300");
      } else if (k % 2 == 0) {
        classes.push("bg-gray-100 hover:bg-gray-50");
      }
      return classes.join(" ");
    },
    openShowAssignAP(employee) {
      axios
        .post("/", {
          query: `
          {
            employeePersonalActions(where:{ employee: "${employee.id}" }) {
              id
              personalAction { name affectsMethod isFixedValue isRecurrent}
              startDate
              endDate
              value
              affectsPaysheet
              isRecurrent
              quincenaUno
              quincenaDos
              tempDisabled
            }
            personalActions {
              id
              type
              name
              affectsPaysheet
              affectsMethod
              isFixedValue
              fixedValue
              isRecurrent
              updateStatus
              active
              deductISR
              baseSalary
              assignable
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          this.apPersonalActionsDetails = data.employeePersonalActions;
          this.apPersonalActions = data.personalActions
            .filter((d) => d.assignable && d.active)
            .map((d) => {
              return {
                ...d,
                type: this.apTypes.find((p) => p.id == d.type),
              };
            });
          this.showAssignAP = true;
        });
    },
    toggleIncludePersonalAction(item) {
      // Obtiene la planilla seleccionada
      const paysheet = this.paysheets.find(
        (p) => p.id === this.selectedPaysheet
      );

      if (paysheet.paysheetType.type === "aguinaldo") {
        return this.$message(
          "No se pueden activar/desactivar APs para planilla tipo aguinaldo"
        );
      }

      const type = !item.tempDisabled ? "desactivar" : "activar";
      this.$confirm(
        `¿Estás seguro que deseas ${type} temporalmente esta accion de personal?`,
        "Confirmación",
        {
          confirmButtonText: `Si, ${type}`,
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";

              axios
                .post("/", {
                  query: `mutation {
                    employeePersonalActionUpdate(
                      where: { id: ${item.id} }
                      data: { tempDisabled: ${!item.tempDisabled} }
                    ){ tempDisabled }
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    item.tempDisabled = !item.tempDisabled;
                    this.getPaysheetData();
                  }
                  1;
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? `Se ha actualizado la accion de personal correctamente`
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = `Si, ${type}`;
                  this.showNewPaysheet = false;
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    updateCustomRenta() {
      var oFile = this.$refs.customRenta.files[0];
      var reader = new FileReader();

      const types = oFile.name.split(".")[1];
      const fileType = ["xlsx", "xls"].some((item) => item == types);
      if (!fileType) {
        return this.$notify({
          title: "Error",
          message:
            "El formato de archivo es incorrecto, solo se permiten xlsx y xls",
          type: "error",
          duration: 3500,
        });
      }

      const app = this;
      const result = [];
      reader.onload = function(e) {
        var data = e.target.result;
        var wb = XLSX.read(data, { type: "binary" });
        wb.SheetNames.forEach((sheetName) => {
          result.push({
            sheetName: sheetName,
            sheet: XLSX.utils.sheet_to_json(wb.Sheets[sheetName]),
          });
        });
        const values = result[0].sheet;
        app.computedEmployees = app.computedEmployees.map((ce) => {
          const taxes = values.find(
            (v) => v.CODIGOANTERIOR == ce.priorCode || v.CODIGOACTUAL == ce.code
          );
          const newtaxes = taxes ? taxes.RENTA : 0;
          return {
            ...ce,
            taxes: newtaxes,
            total: ce.total + ce.taxes - newtaxes,
          };
        });
        app.customRenta = true;
        app.$notify({
          title: "Exito",
          message: "Se ha cargado la renta personalizada",
          type: "success",
          duration: 3500,
        });
        app.showCustomRenta = false;
      };
      reader.readAsBinaryString(oFile);
    },
    formatNumber(value) {
      return formatNumber(value);
    },
    confirmCleanPayrollValue() {
      const paysheet = this.paysheets.find(
        (p) => p.id === this.selectedPaysheet
      );

      // Determinar mensaje según sequence
      let message = "";
      switch (paysheet.sequence) {
        case 1:
          message =
            "¿Estás seguro que deseas limpiar el valor de planilla para la quincena 1? El salario de planilla se establecerá en Q0.00";
          break;
        case 2:
          message =
            "¿Estás seguro que deseas limpiar el valor de planilla para la quincena 2? El salario de planilla se establecerá en Q0.00";
          break;
        default:
          message = `¿Estás seguro que deseas limpiar el valor de planilla para la secuencia ${paysheet.sequence}? El salario de planilla se establecerá en Q0.00`;
      }

      this.$confirm(message, "Confirmación", {
        confirmButtonText: "Sí, limpiar",
        cancelButtonText: "Cancelar",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Procesando...";
            this.cleanPayrollValue(paysheet.sequence);
            instance.confirmButtonLoading = false;
            done();
          } else {
            done();
          }
        },
      });
    },
    cleanPayrollValue(sequence) {
      // Resetear totales antes de recalcular
      this.paysheetTotals = ["", "", "", "", 0, 0, 0, 0, 0, 0, 0, 0];

      const paysheet = this.paysheets.find(
        (p) => p.id === this.selectedPaysheet
      );
      const paysheetType = paysheet.paysheetType;

      // Recalcular todos los empleados con salaryForPayroll = 0
      this.computedEmployees = this.computedEmployees.map((ce) => {
        // Establecer salaryForPayroll a 0
        const newSalaryForPayroll = 0;

        // Recalcular subtotalSalary (sin salaryForPayroll)
        const newSubtotalSalary =
          newSalaryForPayroll + ce.overtime + ce.gratification;

        // Recalcular IGSS (sobre el nuevo subtotal)
        const totalIncome = newSubtotalSalary;
        let newSocialEmployee = 0;

        if (paysheetType.isssDiscount && this.socialForm) {
          const divisibleBy = paysheetType.paysheetFrecuency.id;
          const maxSocial =
            this.socialForm.maxAmount /
            (paysheet.sequence == 2 ? 1 : divisibleBy);
          const socialSalary = totalIncome > maxSocial ? maxSocial : totalIncome;
          newSocialEmployee = (this.socialForm.employee * socialSalary) / 100;
        }

        // Recalcular AFP usando el valor original del empleado
        let newAfpEmployee = ce.afpEmployee;
        
        // Si hay ingreso, recalcular AFP basado en el nuevo totalIncome
        if (totalIncome > 0 && paysheetType.afpDiscount) {
          // Obtener el porcentaje original de AFP del empleado
          const afpPercentage = ce.salaryForPayroll > 0 
            ? (ce.afpEmployee / (ce.salaryForPayroll + ce.overtime + ce.gratification)) * 100
            : 0;
          
          if (afpPercentage > 0) {
            newAfpEmployee = (afpPercentage * totalIncome) / 100;
          } else {
            newAfpEmployee = 0;
          }
        } else if (totalIncome === 0) {
          newAfpEmployee = 0;
        }

        // Recalcular renta (ISR) sobre el nuevo ingreso
        let newTaxes = 0;
        if (paysheetType.rentaDiscount && totalIncome > 0) {
          // Calcular base para ISR (ingreso - IGSS - AFP)
          let aplicable = totalIncome - newSocialEmployee - newAfpEmployee;

          if (aplicable > 0) {
            // Buscar en la tabla de renta
            const range = this.ISRTable.find((t) => {
              return aplicable >= t.from && aplicable <= t.until;
            });

            if (range) {
              const exceso = aplicable - range.applyTo;
              const porcentaje = exceso * (range.percentage / 100);
              newTaxes = porcentaje + parseFloat(range.fixedAmount);
            }

            newTaxes = newTaxes < 0 ? 0 : newTaxes;
          }
        }

        // Recalcular total
        const newTotal =
          newSubtotalSalary -
          newTaxes -
          newSocialEmployee -
          newAfpEmployee +
          ce.discounts;

        // Actualizar totales acumulados
        this.paysheetTotals[4] += newSalaryForPayroll; // Planilla
        this.paysheetTotals[5] += ce.overtime; // H. extra
        this.paysheetTotals[6] += ce.gratification; // Gratifc.
        this.paysheetTotals[7] += newSubtotalSalary; // Subtotal
        this.paysheetTotals[8] += newSocialEmployee; // IGSS
        this.paysheetTotals[9] += newTaxes; // Renta
        this.paysheetTotals[10] += ce.discounts; // Descuen.
        this.paysheetTotals[11] += newTotal; // Pago

        // Retornar el empleado con los nuevos valores
        return {
          ...ce,
          salaryForPayroll: newSalaryForPayroll,
          subtotalSalary: newSubtotalSalary,
          socialEmployee: newSocialEmployee,
          afpEmployee: newAfpEmployee,
          taxes: newTaxes,
          total: newTotal,
        };
      });

      // Marcar que se limpió el valor de planilla
      this.cleanedPayrollValue = true;

      // Notificar éxito
      this.$notify({
        title: "Éxito",
        message:
          "Se ha limpiado el valor de planilla correctamente. Todos los cálculos se han recalculado.",
        type: "success",
        duration: 3500,
      });

      // Actualizar preview si hay uno seleccionado
      if (this.previewDetail) {
        const updatedPreview = this.computedEmployees.find(
          (e) => e.id === this.previewDetail.id
        );
        if (updatedPreview) {
          this.previewDetail = updatedPreview;
        }
      }
    },
    getProcessedEmployeeData(e, comisiones, index, workdays = 10) {
      // Obtiene la planilla seleccionada
      const paysheet = this.paysheets.find(
        (p) => p.id === this.selectedPaysheet
      );

      // Define el tipo de planilla
      const paysheetType = paysheet.paysheetType;

      // Define si es planilla anterior
      let priorPaysheets = false;
      if (
        paysheet.sequence == 2 ||
        ["bono15", "vacacion"].includes(paysheetType.type)
      ) {
        priorPaysheets = this.paysheets.filter(
          (p) => p.year == paysheet.year && p.month == paysheet.month
        );
      }

      // Obtiene fechas de inicio y fin de la planilla
      const [psday, psmonth, psyear] = paysheet.startDate.split("/");
      const [peday, pemonth, peyear] = paysheet.endDate.split("/");
      const paysheetStartDate = new Date(`${psmonth}/${psday}/${psyear}`);
      const paysheetEndDate = new Date(`${pemonth}/${peday}/${peyear}`);

      // Define la fecha de contratacion
      const [cyear, cmonth, cday] = e.contractStartDate.split("-");
      const contractStartDate = new Date(`${cmonth}/${cday}/${cyear}`);

      // Obtiene los dias trasncurridos desde contratacion hasta inicio de planilla
      const daysPastPaysheetStart = differenceInDays(
        contractStartDate,
        paysheetStartDate
      );

      // Se utiliza para identificar si los calculos se deben hacer quincenal o mensual
      let divisibleBy = ["aguinaldo", "vacacion", "bono15"].includes(
        paysheetType.type
      )
        ? 1
        : paysheetType.paysheetFrecuency.id;

      // Genera el nombre completo
      const fullName = `${e.code} - ${e.name1 ? `${e.name1} ` : ""}${
        e.name2 ? `${e.name2} ` : ""
      }${e.name3 ? `${e.name3} ` : ""}${e.lastname1 ? `${e.lastname1} ` : ""}${
        e.lastname2 ? `${e.lastname2} ` : ""
      }${e.lastname3 ? `${e.lastname3} ` : ""}`;

      // Obtiene el listado completo de las acciones de personal
      let personalActions = this.personalActions
        .filter((p) => p.employee.id == e.id)
        .map((p) => {
          const [psyear, psmonth, psday] = p.startDate.split("-");
          const [peyear, pemonth, peday] = p.endDate.split("-");
          const startDate = new Date(`${psmonth}/${psday}/${psyear}`);
          const endDate = new Date(`${pemonth}/${peday}/${peyear}`);
          return {
            ...p,
            startDate,
            endDate,
          };
        });
      personalActions = personalActions.filter((p) => {
        return (
          p.endDate >= paysheetStartDate &&
          p.startDate <= paysheetEndDate &&
          ((paysheet.sequence == 1 && p.quincenaUno) ||
            (paysheet.sequence == 2 && p.quincenaDos))
        );
      });

      // Define el salario inicial
      const increase = personalActions.find((p) => {
        return p.personalAction.baseSalary;
      });
      let salary = increase ? increase.value : e.currentSalary;

      // En caso que sea aguinaldo considera las ultimas comisiones
      if (["aguinaldo", "vacacion", "bono15"].includes(paysheetType.type)) {
        salary =
          salary +
          comisiones
            .filter((c) => c.employee.id == e.id)
            .reduce((a, b) => a + b.value, 0) /
            6;
      }

      // Define el salario para esta planilla
      let deductAmount = 0; // Cuanto dinero se va a descontar
      let increaseAmount = 0; // Cuanto dinero se va a aumentar
      let minusDays = 0; // Cuantos dias son los que se descuenta
      let minusMoney = 0; // Cuanto dinero es el que se descuenta
      let addDays = 0; // Cuantos dias son los que se aumentan
      let addMoney = 0; // Cuantos dinero es el que se aumenta
      let administrativas = personalActions.filter(
        (p) => p.personalAction.type == 1
      );

      // Si la planilla permite descuentos se buscan los descuentos
      if (paysheetType.discounts) {
        minusDays = administrativas
          .filter(
            (d) =>
              d.personalAction.affectsMethod == 1 && // Busca AP cuyo efecto sea en dias
              (d.personalAction.termination || d.personalAction.discount)
          )
          .reduce((a, b) => a + b.amount, 0);

        minusMoney = administrativas
          .filter(
            (d) =>
              d.personalAction.affectsMethod == 2 && d.personalAction.discount
          )
          .reduce((a, b) => a + b.amount, 0);

        if (daysPastPaysheetStart > 0) {
          deductAmount = (salary / 30) * daysPastPaysheetStart;
        }

        deductAmount = deductAmount + (salary / 30) * minusDays + minusMoney;
      }

      // Si la planilla permite gratificaciones se buscan los gratificaciones
      if (paysheetType.gratification) {
        //Cuantos dias se van a aumentar
        addDays = administrativas
          .filter(
            (d) =>
              d.personalAction.affectsMethod == 1 &&
              !d.personalAction.termination &&
              !d.personalAction.discount
          )
          .reduce((a, b) => a + b.amount, 0);

        //Cuanto dinero se va aumentar
        addMoney = administrativas
          .filter(
            (d) =>
              d.personalAction.affectsMethod == 2 &&
              !d.personalAction.discount &&
              d.personalAction.id != 90
          )
          .reduce((a, b) => a + b.amount, 0);

        increaseAmount = (salary / 30) * addDays + addMoney;
      }

      let workedDays =
        paysheetType.paysheetFrecuency.days -
        (daysPastPaysheetStart > 0 ? daysPastPaysheetStart : 0) -
        minusDays;
      const limitDate = new Date(`${new Date().getFullYear()}-12-12`);
      const diffInYears = differenceInYears(limitDate, contractStartDate);

      // Define la cantidad de dias aplicables para el aguinaldo
      if (paysheetType.type == "aguinaldo") {
        if (diffInYears == 0) {
          workedDays = "15";
        } else if (diffInYears < 3) {
          workedDays = "15";
        } else if (diffInYears < 10) {
          workedDays = "19";
        } else {
          workedDays = "21";
        }
      } else if (paysheetType.type == "vacacion") {
        workedDays = "15";
      } else if (paysheetType.type == "bono15") {
        workedDays = paysheet.settings
          ? paysheet.settings.find((s) => s.employeeId === e.id)
            ? paysheet.settings.find((s) => s.employeeId === e.id).days
            : workdays.toString()
          : workdays.toString();
      }

      let salaryForPayroll =
        salary / divisibleBy + increaseAmount - deductAmount;

      // En caso que el tipo de planilla sea aguinaldo, el salary for payroll se calcula diferente

      if (paysheetType.type == "aguinaldo") {
        if (diffInYears == 0) {
          salaryForPayroll =
            (((salary / 30) * 15) / 365) *
            (differenceInDays(limitDate, contractStartDate) + 2);
        } else if (diffInYears < 3) {
          salaryForPayroll = (salary / 30) * 15;
        } else if (diffInYears < 10) {
          salaryForPayroll = (salary / 30) * 19;
        } else {
          salaryForPayroll = (salary / 30) * 21;
        }
      } else if (paysheetType.type == "vacacion") {
        salaryForPayroll = (salary / 30) * 15 * 0.3;
      } else if (paysheetType.type == "bono15") {
        salaryForPayroll = (salary / 30) * parseInt(workedDays);
      }

      // Obtiene el listado de horas extra por empleado
      let fovertime = this.overtimes.filter((o) => o.employee.id == e.id);

      // Define el tiempo extra en caso existan aprobados
      let overtime = 0;

      // Si la planilla permite horas extra se obtiene el total
      if (paysheetType.overtime) {
        overtime = fovertime.reduce((a, b) => {
          return a + b.hours * b.overtimeType.factor * (salary  * 12 / 365 / 8);
        }, 0);
      } else {
        // Se reinicia el arreglo de horas extra
        fovertime = [];
      }

      // Se obtiene el listado de Gratificaciones mayores a $0 a las que no se le descuenta 10% renta
      let gratificaciones = personalActions.filter((p) => {
        return (
          p.value > 0 &&
          p.personalAction.type === 2 &&
          !p.personalAction.baseSalary &&
          !p.personalAction.termination &&
          !p.personalAction.discount
        );
      });

      let gratificationApplicable = 0;
      let gratificationNOApplicable = 0;

      // En caso que la planilla permita gratificaciones
      if (paysheetType.gratification) {
        // Aplica descuentos normales
        gratificationApplicable = gratificaciones
          .filter((g) => !g.personalAction.deductISR && !g.tempDisabled)
          .reduce((a, b) => a + b.value, 0);

        // No aplica descuentos normales
        gratificationNOApplicable = gratificaciones
          .filter((g) => g.personalAction.deductISR && !g.tempDisabled)
          .reduce((a, b) => a + b.value, 0);
      } else {
        // Si no permite gratificaciones retorna un objeto vacio
        gratificaciones = [];
      }

      // Obtiene los Descuentos menores a $0
      let descuentos = personalActions
        .filter((p) => p.value < 0)
        .map((d) => {
          return {
            ...d,
            value: d.value * (d.personalAction.discount ? -1 : 1),
          };
        });

      // Agrega descuento de la procuradoria en caso exista
      const procuDiscount = descuentos.find((d) => d.personalAction.id == 74);

      let discounts = 0;
      // Si la planilla permite descuentos
      if (paysheetType.discounts) {
        /**
         * Se obtiene el total de los descuentos
         * se mantiene el arreglo descuentos
         */
        discounts = descuentos
          .filter((d) => !d.tempDisabled)
          .reduce((a, b) => a + b.value, 0);

        // En caso que sea planilla del tipo aguinaldo y tenga descuento de procuraduria
      } else if (
        ["vacacion", "aguinaldo", "bono15"].includes(paysheetType.type) &&
        procuDiscount
      ) {
        /**
         * Se calcula el descuento para la procu
         * Se devuelve el arrelgo descuentos con 1 solo descuento con el valor actualizado
         */
        discounts = ((salaryForPayroll * e.procuAguinaldo) / 100) * -1;
        descuentos = [{ ...procuDiscount, value: discounts }];
      } else {
        // Se deja el arreglo descuentos vacio
        descuentos = [];
      }

      // Define el salario del periodo
      let totalIncome = salaryForPayroll + overtime + gratificationApplicable;
      let socialSalary = 0;
      let socialEmployee = 0;
      let socialEmployer = 0;
      const ppEmployees = priorPaysheets
        ? this.priorPaysheets.filter((pp) => pp.employee.id == e.id)
        : [];
      const priorTotalIncome = priorPaysheets
        ? ppEmployees.reduce((a, b) => a + b.subtotalSalary, 0) -
          this.priorPersonalActions
            .filter((ppa) => ppa.PAdeductISR && ppa.employee.id == e.id)
            .reduce((a, b) => a + b.value, 0)
        : 0;
      const accumIncome = totalIncome + priorTotalIncome;
      //en caso que la planilla permita descuentos sociales
      if (paysheetType.isssDiscount) {
        // OBTIENE LOS DATOS DE LA PLANILLAS DEL MES PARA CALCULAR
        if (priorPaysheets) {
          socialSalary =
            accumIncome > this.socialForm.maxAmount
              ? this.socialForm.maxAmount
              : accumIncome;
        } else {
          socialSalary =
            totalIncome >
            this.socialForm.maxAmount /
              (paysheet.sequence == 2 ? 1 : divisibleBy)
              ? this.socialForm.maxAmount /
                (paysheet.sequence == 2 ? 1 : divisibleBy)
              : totalIncome;
        }

        //console.log("gratificaciones: " + JSON.stringify(gratificaciones));
        socialEmployee =
          this.socialForm !== null
            ? (this.socialForm.employee * socialSalary) / 100
            : 0;

        socialEmployee =
          socialEmployee -
          (ppEmployees
            ? ppEmployees
                .filter((pp) => pp.employee.id == e.id)
                .reduce((a, b) => a + b.socialEmployee, 0)
            : 0);

        socialEmployer =
          this.socialForm !== null
            ? (this.socialForm.employer * socialSalary) / 100
            : 0;
      }

      let afpEmployee = 0;
      let afpEmployer = 0;

      // Si la planilla permite descuentos de AFP
      if (paysheetType.afpDiscount) {
        const employeeDocumentTypes = e.documents
          .filter((d) => d.number || d.number != null)
          .map((d) => d.documentType.id);

        let hasIPSFA =
          e.documents.filter(
            (r) =>
              r.documentType.id == 42 && r.number !== "" && r.number !== null
          ).length > 0
            ? true
            : false;

        // PARA IPSFA
        if (hasIPSFA) {
          afpEmployee = (this.pensionForm.ipsfa.employee * totalIncome) / 100;
          afpEmployer = (this.pensionForm.ipsfa.employer * totalIncome) / 100;
          console.log("soy ipsfa");
          console.log(
            "afpEmployee:" +
              afpEmployee +
              " ipsfa.employee: " +
              this.pensionForm.ipsfa.employee
          );
        } else if (
          // PARA AFP
          employeeDocumentTypes.some((d) =>
            this.pensionForm.afp.documentTypes.includes(d)
          )
        ) {
          afpEmployee = (this.pensionForm.afp.employee * totalIncome) / 100;
          afpEmployer = (this.pensionForm.afp.employer * totalIncome) / 100;
        }
      }

      let taxes = 0;

      // Si la planilla permite descuentos de renta
      if (paysheetType.rentaDiscount) {
        let formula = "";
        for (const e of this.ISRElements) {
          switch (e.key) {
            case "salary":
              formula += priorPaysheets ? accumIncome : totalIncome;
              break;
            case "pen_emp":
              formula +=
                afpEmployee +
                (priorPaysheets
                  ? ppEmployees.reduce((a, b) => a + b.afpEmployee, 0)
                  : 0
                ).roundDecimal();
              break;
            case "soc_emp":
              formula +=
                socialEmployee +
                (priorPaysheets
                  ? ppEmployees.reduce((a, b) => a + b.socialEmployee, 0)
                  : 0
                ).roundDecimal();
              break;
            default:
              formula += e.key;
              break;
          }
        }

        // Encuentra la cantidad aplicable
        let aplicable = eval(formula);

        //aplicaremos aca el descuento para los ISRTable que tengan id 18, que se le restara 66.67
        let rangus = this.ISRTable.find((t) => {
          return aplicable >= t.from && aplicable <= t.until;
        });
        if (rangus && rangus.id == 18) {
          if (aplicable <= 379.17) {
            aplicable = aplicable - 66.67;
          }
          rangus = this.ISRTable.find((t) => {
            return aplicable >= t.from && aplicable <= t.until;
          });
        }

        /**
         * Si el tipo de planilla es aguinaldo se valida que el aplicable sea mayor a 730 || 1100
         * o si no es aguinaldo se aplica normalemente.
         */

        let renta_exonerada = 1500;
        if (paysheet.settings != null) {
          if (paysheet.settings.renta_exonerada != null) {
            renta_exonerada = parseInt(paysheet.settings.renta_exonerada);
          }
        }

        if (
          (paysheetType.type == "aguinaldo" && aplicable >= renta_exonerada) ||
          paysheetType.type != "aguinaldo"
        ) {
          aplicable =
            paysheetType.type == "aguinaldo"
              ? aplicable - renta_exonerada
              : aplicable;
          // Se aplica la tabla a lo apliable
          let range = this.ISRTable.find((t) => {
            return aplicable >= t.from && aplicable <= t.until;
          });

          //console.log("aplicable: " + aplicable);
          //console.log("range: " + JSON.stringify(range));
          if (priorPaysheets) {
            range = this.ISRTableM.find((t) => {
              return aplicable >= t.from && aplicable <= t.until;
            });
          }

          if (range != null) {
            if (range && range.id == 10) {
              if (aplicable <= 758.34) {
                aplicable = aplicable - 133.34;
                range = this.ISRTableM.find((t) => {
                  return aplicable >= t.from && aplicable <= t.until;
                });
              }
            }

            taxes =
              //((aplicable - range.applyTo) < 0 ? 0 : (aplicable - range.applyTo) * (range.percentage / 100) + parseFloat(range.fixedAmount));
              (aplicable - range.applyTo) * (range.percentage / 100) +
              parseFloat(range.fixedAmount);
            //console.log("taxes:", taxes);
            //console.log("aplicable:", aplicable);
            //console.log("range:", range);
            //console.log("range.applyTo:", range.applyTo);
            //console.log("range.percentage:", range.percentage);
            //console.log("range.fixedAmount:", range.fixedAmount);

            taxes =
              taxes -
              (priorPaysheets
                ? ppEmployees.reduce((a, b) => a + b.taxes, 0)
                : 0);

            //console.log("taxes after priorPaysheets deduction:", taxes);

            taxes = taxes < 0 ? 0 : taxes;
          }
        }
      }

      this.paysheetTotals[4] =
        this.paysheetTotals[4] +
        (workedDays == 0 ? 0 : salaryForPayroll.roundDecimal());
      this.paysheetTotals[5] =
        this.paysheetTotals[5] +
        (workedDays == 0 ? 0 : overtime.roundDecimal());
      this.paysheetTotals[6] =
        this.paysheetTotals[6] +
        (workedDays == 0
          ? 0
          : (
              gratificationApplicable + gratificationNOApplicable
            ).roundDecimal()); // gratification
      this.paysheetTotals[7] =
        this.paysheetTotals[7] +
        (workedDays == 0
          ? 0
          : salaryForPayroll.roundDecimal() +
            overtime.roundDecimal() +
            (
              gratificationApplicable + gratificationNOApplicable
            ).roundDecimal()); // subtotal salary
      this.paysheetTotals[8] =
        this.paysheetTotals[8] +
        (workedDays == 0 ? 0 : socialEmployee.roundDecimal());
      this.paysheetTotals[9] =
        this.paysheetTotals[9] +
        (workedDays == 0
          ? 0
          : (taxes + gratificationNOApplicable * 0.0).roundDecimal()); // taxes
      this.paysheetTotals[10] =
        this.paysheetTotals[10] +
        (workedDays == 0 ? 0 : discounts.roundDecimal());
      this.paysheetTotals[11] =
        this.paysheetTotals[11] +
        (workedDays == 0
          ? 0
          : salaryForPayroll.roundDecimal() +
            overtime.roundDecimal() +
            (
              gratificationApplicable + gratificationNOApplicable
            ).roundDecimal() -
            (taxes + gratificationNOApplicable * 0.0).roundDecimal() -
            socialEmployee.roundDecimal() -
            afpEmployee.roundDecimal() +
            discounts.roundDecimal());

      return {
        index: index.toString(),
        id: e.id,
        code: e.code,
        priorCode: e.priorCode,
        name1: e.name1,
        name2: e.name2,
        name3: e.name3,
        lastname1: e.lastname1,
        lastname2: e.lastname2,
        lastname3: e.lastname3,
        fullName,
        workedDays: workedDays.toString(),
        missedDays: minusDays.toString(),
        salary: parseFloat(salary.toFixed(2)),
        salaryForPayroll: workedDays == 0 ? 0 : salaryForPayroll.roundDecimal(),
        overtime: workedDays == 0 ? 0 : overtime.roundDecimal(),
        gratification:
          workedDays == 0
            ? 0
            : (
                gratificationApplicable + gratificationNOApplicable
              ).roundDecimal(),
        subtotalSalary:
          workedDays == 0
            ? 0
            : salaryForPayroll.roundDecimal() +
              overtime.roundDecimal() +
              (
                gratificationApplicable + gratificationNOApplicable
              ).roundDecimal(),
        discounts: workedDays == 0 ? 0 : discounts.roundDecimal(),
        taxes:
          workedDays == 0
            ? 0
            : (taxes + gratificationNOApplicable * 0.0).roundDecimal(),
        socialEmployee: workedDays == 0 ? 0 : socialEmployee.roundDecimal(),
        afpEmployee: workedDays == 0 ? 0 : afpEmployee.roundDecimal(),
        socialEmployer: workedDays == 0 ? 0 : socialEmployer.roundDecimal(),
        afpEmployer: workedDays == 0 ? 0 : afpEmployer.roundDecimal(),
        total:
          workedDays == 0
            ? 0
            : salaryForPayroll.roundDecimal() +
              overtime.roundDecimal() +
              (
                gratificationApplicable + gratificationNOApplicable
              ).roundDecimal() -
              (taxes + gratificationNOApplicable * 0.0).roundDecimal() -
              socialEmployee.roundDecimal() -
              afpEmployee.roundDecimal() +
              discounts.roundDecimal(),
        gratificaciones,
        descuentos,
        horasextra: fovertime,
        administrativas,
        oldDepartment: e.oldDepartment ? e.oldDepartment.name : "",
        oldCostCenter: e.oldCostCenter ? e.oldCostCenter.name : "",
      };
    },
    updateEmployeeWorkDays(previewDetail, { days }, formName) {
      const employee = this.rawEployees.find((e) => e.id == previewDetail.id);

      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }

        this.$confirm(
          "¿Estás seguro que deseas actualizar los días de bono 15?",
          "Confirmación",
          {
            confirmButtonText: "Si, actualizar",
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                const index = this.computedEmployees.findIndex(
                  (e) => e.id == previewDetail.id
                );

                axios
                  .post("/", {
                    query: `mutation {
                    updatePaysheetSettings(
                      data: {employeeId: "${previewDetail.id}", days: ${days}},
                      where:{ id: "${this.selectedPaysheet}"}
                    )
                  }`,
                  })
                  .then(async (res) => {
                    const { data, errors } = res;

                    const comisiones = await this.getComissions();
                    this.paysheetTotals[4] =
                      this.paysheetTotals[4] - previewDetail.salaryForPayroll;
                    this.paysheetTotals[5] =
                      this.paysheetTotals[5] - previewDetail.overtime;
                    this.paysheetTotals[6] =
                      this.paysheetTotals[6] - previewDetail.gratification; // gratification
                    this.paysheetTotals[7] =
                      this.paysheetTotals[7] - previewDetail.subtotalSalary; // subtotal salary
                    this.paysheetTotals[8] =
                      this.paysheetTotals[8] - previewDetail.socialEmployee;
                    this.paysheetTotals[9] =
                      this.paysheetTotals[9] - previewDetail.taxes; // taxes
                    this.paysheetTotals[10] =
                      this.paysheetTotals[10] - previewDetail.discounts;
                    this.paysheetTotals[11] =
                      this.paysheetTotals[11] - previewDetail.total;

                    const newEmployeeData = await this.getProcessedEmployeeData(
                      employee,
                      comisiones,
                      index + 1,
                      days
                    );

                    if (data && R.isNil(errors)) {
                      this.computedEmployees.splice(index, 1, newEmployeeData);
                    }
                    this.previewDetail = newEmployeeData;
                    this.showBonusDays = false;
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se ha actualizado los días de bonus 15 correctamente"
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "Si, crear";
                    this.showNewPaysheet = false;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    async getComissions() {
      // Obtiene la planilla seleccionada
      const paysheet = this.paysheets.find(
        (p) => p.id === this.selectedPaysheet
      );
      const [peday, pemonth, peyear] = paysheet.endDate.split("/");

      const selectedPaysheets = this.paysheets
        .filter((p) => {
          const lastSixMonths = [];
          for (let i = 0; i < 6; i++) {
            const calc = parseInt(pemonth) - i;
            const month =
              calc <= 0
                ? 12 - (i - 2) < 10
                  ? `0${12 - (i - 2)}`
                  : (12 - (i - 2)).toString()
                : `0${calc}`;
            month = month.length == 3 ? month.slice(1) : month;
            const year = calc <= 0 ? (parseInt(peyear) - 1).toString() : peyear;
            lastSixMonths.push(`${month}-${year}`);
          }

          return lastSixMonths.includes(
            p.endDate
              .split("/")
              .splice(1, 2)
              .join("-")
          );
        })
        .map((p) => parseInt(p.id));
      const {
        data: {
          data: { personalActionHistory },
        },
      } = await axios.post("/", {
        query: `{
                personalActionHistory(in: {paysheet: ${JSON.stringify(
                  selectedPaysheets
                )}} where: {personalAction:75}){ 
                  value
                  employee { id }
                }
              }`,
      });
      return personalActionHistory;
    },
    showBonusDaysDialog(days) {
      if (this.$refs["bonus15Days"]) {
        this.$refs["bonus15Days"].resetFields();
      }
      this.bonusPaysheet.days = days;
      this.showBonusDays = true;
    },
  },
  computed: {
    activePaysheets() {
      return this.paysheets.filter((p) => p.active);
    },
    paysheetDetails() {
      const selectedPaysheet = this.selectedPaysheet;
      if (!R.isEmpty(selectedPaysheet)) {
        axios
          .post("/", {
            query: `{
              employees (where: { show: true paysheetType: ${selectedPaysheet} }) {
                id
                name1
                name2
                name3
                lastname1
                lastname2
                lastname3
                currentSalary
              }
            }`,
          })
          .then((res) => {
            const { data, errors } = res.data;
            if (R.isNil(errors)) {
              this.employees = data.employees;
            }
          });
        return this.paysheets.find((p) => p.id === selectedPaysheet);
      } else {
        return {};
      }
    },
    filteredEmployees() {
      return this.computedEmployees.filter((e) => {
        let filterByName = true;
        let filterByNegative = true;
        if (this.searchValue != "") {
          filterByName = e.fullName
            .toLowerCase()
            .includes(this.searchValue.toLowerCase());
        }
        if (this.negativePayments) {
          filterByNegative = e.total < 0;
        }

        return filterByName && filterByNegative;
      });
    },
    allowCustomRenta() {
      if (this.selectedPaysheet) {
        return this.paysheets.find((p) => p.id == this.selectedPaysheet)
          .allowCustomRenta;
      }
      return false;
    },
  },
};
</script>
